"use client";

import Link from "next/link";
import { ArrowUpRight } from "lucide-react";

import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type CTAButtonProps = ButtonProps & {
  href: string;
  text: string;
  Icon?: typeof ArrowUpRight;
};

export function CTAButton({
  href,
  text,
  Icon = ArrowUpRight,
  className,
  ...rest
}: CTAButtonProps) {
  return (
    <div className="transition-transform duration-200 hover:-translate-y-0.5 active:scale-[0.98]">
      <Button asChild className={cn("gap-2 rounded-full", className)} {...rest}>
        <Link href={href} prefetch={false}>
          <span>{text}</span>
          <Icon className="h-4 w-4" />
        </Link>
      </Button>
    </div>
  );
}
